module.exports = __webpack_public_path__ + "img/laptop.7bfa0fa8.png";